import React, { useState, useCallback } from "react";
import { Alert, Button, Modal } from "components/bootstrap";
import { ModalSubmit } from "components/common";
import Agree from "./Agree";
import KinesisSetupSteps from "./KinesisSetupSteps";
const SetupModal = ({ onSubmit, onCancel, groupName, streamName }) => {
  const [agreed, setAgreed] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const buttonOtherText = !error && !success ? "Creating..." : "Close";
  const buttonText = success ? "Continue Setup" : buttonOtherText;
  const handleSuccess = () => {
    setSuccess(true);
    setError(false);
  };
  const handleError = useCallback(() => {
    setSuccess(false);
    setError(true);
  }, []);
  return /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: () => {
  } }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, agreed ? "Executing Auto-Setup" : "Kinesis Auto Setup Agreement")), /* @__PURE__ */ React.createElement(Modal.Body, null, agreed ? /* @__PURE__ */ React.createElement(KinesisSetupSteps, { onSuccess: handleSuccess, onError: handleError }) : /* @__PURE__ */ React.createElement(Agree, { groupName, streamName }), agreed && success && /* @__PURE__ */ React.createElement(Alert, { key: "delayedLogs", bsStyle: "warning" }, "It may take up to ten minutes for the first messages to arrive in the Kinesis stream. The Kinesis Health Check in the following step will not complete successfully until messages are present in the stream. Please see the official", " ", /* @__PURE__ */ React.createElement(
    "a",
    {
      href: "https://docs.aws.amazon.com/AmazonCloudWatch/latest/logs/Subscriptions.html",
      target: "_blank",
      rel: "noopener noreferrer"
    },
    "CloudWatch Subscriptions"
  ), " ", "documentation for more information.")), /* @__PURE__ */ React.createElement(Modal.Footer, null, agreed ? /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: success ? onSubmit : onCancel, type: "button", disabled: !error && !success }, buttonText) : /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      submitButtonText: "I Agree! Create these AWS resources now.",
      onSubmit: () => setAgreed(true),
      submitButtonType: "button",
      onCancel
    }
  )));
};
export default SetupModal;
